export const REPOSITORY_CLEAR = 'REPOSITORY_CLEAR';
export const REPOSITORY_FETCH = 'REPOSITORY_FETCH';
export const REPOSITORY_SELECTED = 'REPOSITORY_SELECTED';

export default {
    clear: REPOSITORY_CLEAR,
    fetch: REPOSITORY_FETCH,
    selected: REPOSITORY_SELECTED
};
